
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#fff","xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M7.143 2.428v-.495c0-.239.194-.433.433-.433h.848c.24 0 .433.194.433.433v.495C11.765 2.848 14 5.378 14 8.433c0 3.35-2.686 6.067-6 6.067s-6-2.716-6-6.067C2 5.377 4.235 2.85 7.143 2.428zm.889 1.455v4.563l3.16 3.195A4.561 4.561 0 0012.5 8.433c0-2.502-1.997-4.532-4.468-4.55zm5.16-.82l.556.64a.433.433 0 11-.654.568l-.556-.64a.433.433 0 11.654-.568z"}})])
          )
        }
      }
    